import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { UncontrolledTooltip } from 'reactstrap';
import { history } from '../../../../store/store';
import { addParam } from "../../../../api/helper";
import { ROUTE_CLIENT_CAMPAIGN_VIEW } from "../../../../config/routes";
import { ACL } from '../../../../config/constants';

function EditCampaignComponent(props) {
  const { index, id } = props;

  if (! ACL.CLIENT.CAMPAIGNS.CREATE.hasAccess()) {
    return null;
  }

  return (
    <Fragment>
      <Link
        to={ addParam(
          ROUTE_CLIENT_CAMPAIGN_VIEW,
          {
            ":id": id,
          }
        ) }
        id={`edit-icon-${ index }`}
        className="cursor-pointer mr-2 link-icon-color"
        onClick={ e => {
          e.preventDefault();
          history.push(addParam(
            ROUTE_CLIENT_CAMPAIGN_VIEW,
            {
              ":id": id,
            }
          ));
        }}
        aria-label={ props.intl.formatMessage({ id: "components.pages.campaignManagement.actionButtons.edit_campaign" }) }
      >
        <FontAwesomeIcon
          size="lg"
          pointerEvents="none"
          icon={ faEdit }
        />
      </Link>

      <UncontrolledTooltip
        delay={ 0 }
        target={ `edit-icon-${ index }` }
        modifiers={
          {
            preventOverflow: {
              enabled: true,
              boundariesElement: 'body'
            }
          }
        }
      >
        { props.intl.formatMessage({ id: "components.pages.campaignManagement.actionButtons.edit_campaign" }) }
      </UncontrolledTooltip>
    </Fragment>
  );
}

const EditCampaign = injectIntl(EditCampaignComponent);
export { EditCampaign, EditCampaignComponent }
